export default __webpack_public_path__ + "static/media/manasi.085ceb57.jpg";